// extracted by mini-css-extract-plugin
export default {"list_container":"List_list_container__DKA9E","list_item":"List_list_item__XzxSE"};